import React from 'react';
import { Container } from '../../components/Grid';
import Hero from '../../components/Hero';
import Image from '../../components/Image';
import Layout from '../../components/Layout';
import Section from '../../components/Section';
import Button from '../../components/Button';

const ClassroomResourcesPage = () => {
  return (
    <Layout title="Learning Resources">
      <Hero
        mediaSource="classroomresources-hero.png"
        className="classroom-hero mb-0"
      >
        <Container className="classroom-hero__content">
          <Image
            filename="classroom-hero-cosmos-leftside.png"
            className="classroom-hero__content__cosmos-leftside"
          />
          <Image
            filename="classroom-hero-cosmos-rightside.png"
            className="classroom-hero__content__cosmos-rightside"
          />
          <Image
            filename="classroom-hero-astronaut.png"
            className="classroom-hero__content__astronaut"
          />

          <h1 className="title classroom-hero__content__title">
            Learning <br /> <br />
            Resources
          </h1>
        </Container>
      </Hero>
      <Section className="learning-resources-main-content-section">
        <Container>
          <div className="learning-resources-grid">
            <div className="learning-resources-grid__skills-section">
              <h2>Discover New Ways to Teach Fundamental Literacy Skills</h2>
              <div className="learning-resources-grid__skills-section-buttons">
                <Button to="/classroom-resources/phonological-awareness">
                  Phonological Awareness
                </Button>
                <Button to="/classroom-resources/phonics">Phonics</Button>
                <Button to="/classroom-resources/fluency">Fluency</Button>
                <Button to="/classroom-resources/vocabulary">Vocabulary</Button>
                <Button to="/classroom-resources/reading-comprehension">
                  Reading Comprehension
                </Button>
              </div>
            </div>
            <div className="learning-resources-grid__quote-section">
              <Image
                objectFit="contain"
                filename="rocket.png"
                className="learning-resources-grid__quote-section-rocket"
              />
              <h2>
                Some 34% of students are below basic reading level in the fourth
                grade.
              </h2>
              <p>—U.S. National Center for Education Statistics</p>
              <Image
                objectFit="contain"
                filename="astronaut-with-dog.png"
                className="learning-resources-grid__quote-section-astronaut"
              />
            </div>
            <div className="learning-resources-grid__resources">
              <h2>How to Use These Resources</h2>
              <p>
                This site is designed to guide you through a step-by-step
                approach to mastering and applying the five foundational keys of
                literacy. Follow this progression to make the most of your
                learning experience.
              </p>
              <div className="learning-resources-grid__resource-item">
                <Image
                  filename="03-classroom-numbers-1.png"
                  className="classroom-intro__how-to-numbers learning-resources-grid__resource-item-number"
                />
                <div className="learning-resources-grid__resource-item-content">
                  <h2>Start with the Explainer Video</h2>
                  <p>
                    Watch the explainer video to understand the key concepts of
                    each big idea of literacy.
                  </p>
                </div>
                <Image
                  objectFit="contain"
                  filename="graphic-video.png"
                  className="learning-resources-grid__resource-item-image"
                />
              </div>
              <div className="learning-resources-grid__resource-item">
                <Image
                  filename="03-classroom-numbers-2.png"
                  className="classroom-intro__how-to-numbers learning-resources-grid__resource-item-number"
                />
                <div className="learning-resources-grid__resource-item-content">
                  <h2>Dive into the Microlearns</h2>
                  <p>
                    Complete the 6–8 minute, self-paced modules for each big
                    idea. These modules provide research-based strategies and
                    activities you can immediately use with your students.
                  </p>
                </div>
                <Image
                  objectFit="contain"
                  filename="graphic-module.png"
                  className="learning-resources-grid__resource-item-image"
                />
              </div>
              <div className="learning-resources-grid__resource-item">
                <Image
                  filename="03-classroom-numbers-3.png"
                  className="classroom-intro__how-to-numbers learning-resources-grid__resource-item-number"
                />
                <div className="learning-resources-grid__resource-item-content">
                  <h2>See the Strategies in Action</h2>
                  <p>
                    Watch the masterclass video, where a teacher demonstrates
                    these strategies in a real-world classroom setting.
                  </p>
                </div>
                <Image
                  objectFit="contain"
                  filename="graphic-masterclass.png"
                  className="learning-resources-grid__resource-item-image"
                />
              </div>
              <div className="learning-resources-grid__resource-item">
                <Image
                  filename="03-classroom-numbers-4.png"
                  className="classroom-intro__how-to-numbers learning-resources-grid__resource-item-number"
                />
                <div className="learning-resources-grid__resource-item-content">
                  <h2>Equip Yourself with Task Cards</h2>
                  <p>
                    Print the task cards to keep these strategies at your
                    fingertips and use the printable manipulatives to support
                    hands-on learning with students.
                  </p>
                </div>
                <Image
                  objectFit="contain"
                  filename="graphic-taskcards.png"
                  className="learning-resources-grid__resource-item-image"
                />
              </div>
              <div className="learning-resources-grid__resource-item">
                <Image
                  filename="03-classroom-numbers-5.png"
                  className="classroom-intro__how-to-numbers learning-resources-grid__resource-item-number"
                />
                <div className="learning-resources-grid__resource-item-content">
                  <h2>Apply What You’ve Learned</h2>
                  <p>
                    Use the ready-to-use activity to teach foundational literacy
                    skills like phonics, vocabulary, and comprehension directly
                    in your classroom or after-school program.
                  </p>
                </div>
                <Image
                  objectFit="contain"
                  filename="03-classroom-graphic-5-rocket.png"
                  className="learning-resources-grid__resource-item-image"
                />
              </div>
              <div className="learning-resources-grid__why-this-approach-works">
                <h2>Why This Approach Works</h2>
                <p>
                  Each step builds on the previous one, helping you gain
                  foundational knowledge, see effective strategies in practice,
                  and implement them confidently. Whether you’re a classroom
                  teacher or afterschool professional, these resources provide
                  the tools you need to create engaging, impactful literacy
                  experiences for K–2 learners.
                </p>
              </div>
            </div>
          </div>
        </Container>
      </Section>
    </Layout>
  );
};

export default ClassroomResourcesPage;
